import API_BASE_URL from '../Config';

const getAuthHeader = () => ({
    'Authorization': `Bearer ${localStorage.getItem('token')}`
});

export const getSucursales = async () => {
    const response = await fetch(`${API_BASE_URL}/sucursales`, {
        headers: getAuthHeader()
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener sucursales`);
    return response.json();
};

export const getSucursalesPaginadas = async (page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_BASE_URL}/sucursales/page?page=${page}&size=${size}&search=${search}`, {
        headers: getAuthHeader()
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener sucursales paginadas`);
    return response.json();
};

export const getSucursalById = async (id) => {
    const response = await fetch(`${API_BASE_URL}/sucursales/${id}`, {
        headers: getAuthHeader()
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al obtener la sucursal`);
    return response.json();
};

export const createSucursal = async (sucursal) => {
    const response = await fetch(`${API_BASE_URL}/sucursales`, {
        method: 'POST',
        headers: {
            ...getAuthHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(sucursal)
    });
    if (!response.ok) {
        const msg = await response.text();
        throw new Error(`Error ${response.status}: ${msg || 'Error al crear sucursal'}`);
    }
    return response.json();
};

export const updateSucursal = async (id, sucursal) => {
    const response = await fetch(`${API_BASE_URL}/sucursales/${id}`, {
        method: 'PUT',
        headers: {
            ...getAuthHeader(),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(sucursal)
    });
    if (!response.ok) {
        const msg = await response.text();
        throw new Error(`Error ${response.status}: ${msg || 'Error al actualizar sucursal'}`);
    }
    return response.json();
};

export const deleteSucursal = async (id) => {
    const response = await fetch(`${API_BASE_URL}/sucursales/${id}`, {
        method: 'DELETE',
        headers: getAuthHeader()
    });
    if (!response.ok) throw new Error(`Error ${response.status}: Error al eliminar sucursal`);
};
